module.exports = __webpack_public_path__ + "img/globe.cbfd9dfd.svg";